import { jsx as _jsx } from "react/jsx-runtime";
export default function SupportIcon(param) {
    let { color } = param;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "23",
        height: "23",
        fill: "none",
        viewBox: "0 0 23 23",
        children: /*#__PURE__*/ _jsx("path", {
            fill: color ? color : "#3F4041",
            d: "M21.418 11.567a9.659 9.659 0 10-18.966 0A1.614 1.614 0 00.87 13.18v4.304A1.614 1.614 0 002.484 19.1h1.2v1.06a1.934 1.934 0 001.934 1.932h6.524a.538.538 0 000-1.076H5.618a.858.858 0 01-.858-.856v-.242h2.674a1.614 1.614 0 001.614-1.614v-5.937a1.614 1.614 0 00-1.614-1.614H4.222a.538.538 0 00-.538.538v.269h-.132a8.7 8.7 0 01-.199-1.816 8.582 8.582 0 1116.965 1.83h-.132v-.27a.538.538 0 00-.538-.538h-3.212a1.614 1.614 0 00-1.614 1.614v5.93a1.614 1.614 0 001.614 1.614h3.212a.538.538 0 00.538-.538v-.27h1.2A1.614 1.614 0 0023 17.502v-4.304a1.614 1.614 0 00-1.582-1.63zm-16.658.269h2.674a.538.538 0 01.538.538v5.934a.538.538 0 01-.538.538H4.76v-7.018.008zm-1.076 6.187h-1.2a.538.538 0 01-.538-.538v-4.304a.538.538 0 01.538-.538h1.2v5.38zm15.426.807h-2.674a.538.538 0 01-.538-.538v-5.926a.538.538 0 01.538-.538h2.674v7.018-.016zm2.814-1.345a.538.538 0 01-.538.538h-1.2v-5.38h1.2a.538.538 0 01.538.538v4.304z"
        })
    });
}
